import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=2b4b244d&scoped=true&lang=pug&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"
import style0 from "./Services.vue?vue&type=style&index=0&id=2b4b244d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b244d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4b244d')) {
      api.createRecord('2b4b244d', component.options)
    } else {
      api.reload('2b4b244d', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=2b4b244d&scoped=true&lang=pug&", function () {
      api.rerender('2b4b244d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileFSFB/components/Services.vue"
export default component.exports